<template>
  <ul class="b2b-color-selector">
    <li v-for="(color, index) in colors" :key="index" class="b2b-color-selector__list-item">
      <label :for="`b2b-color-swatch-${color}`" class="b2b-color-selector__label">
        <input
          :id="`b2b-color-swatch-${color}`"
          v-model="active"
          type="radio"
          :aria-label="`${color} swatch`"
          class="b2b-color-selector__color-check"
          :data-color="color"
          data-id="#"
          data-url="#"
          :name="radioName"
          :value="color"
        />
        <swatch :color="color" />
      </label>
    </li>
  </ul>
</template>

<script>
import Swatch from '@/components/Swatch';

export default {
  components: {Swatch},
  props: {
    activeColor: {
      type: String,
      default: '',
    },
    colors: {
      type: Array,
      default: () => [],
    },
    radioName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: this.activeColor,
    };
  },
};
</script>
